import React from 'react';

import { Badge } from '@ergeon/core-components';

interface ToolkitContextMessageProps {
  zipCode?: string | null;
  permitNeeded?: string | null;
  maxFenceHeights?: {
    front?: string | null;
    side?: string | null;
    rear?: string | null;
  } | null;
}

export const ToolkitContextMessage: React.FC<ToolkitContextMessageProps> = ({
  zipCode,
  permitNeeded,
  maxFenceHeights,
}) => {
  const getPermitBadgeFlavor = (): 'warning' | 'success' | 'regular' => {
    if (permitNeeded === 'yes') return 'warning';
    if (permitNeeded === 'no') return 'success';
    return 'regular';
  };

  const getPermitLabel = () => {
    if (permitNeeded === 'yes') return 'Permit Required';
    if (permitNeeded === 'no') return 'No Permit Required';
    return 'Permit Status Unknown';
  };

  return (
    <div className="flex flex-col justify-start gap-1 w-full text-left">
      {zipCode && (
        <div className="flex flex-col gap-1">
          <strong>Zip Code: {zipCode}</strong>
        </div>
      )}

      {permitNeeded && (
        <div className="flex gap-2">
          <Badge flavor={getPermitBadgeFlavor()} value={getPermitLabel()} />
        </div>
      )}

      {maxFenceHeights && (maxFenceHeights.front || maxFenceHeights.side || maxFenceHeights.rear) && (
        <div className="flex flex-col gap-1 paragraph-2">
          <span className="font-semibold">Max Fence Heights:</span>
          <div className="flex gap-3">
            {maxFenceHeights.front && <span>Front: {maxFenceHeights.front}</span>}
            {maxFenceHeights.side && <span>Side: {maxFenceHeights.side}</span>}
            {maxFenceHeights.rear && <span>Rear: {maxFenceHeights.rear}</span>}
          </div>
        </div>
      )}
    </div>
  );
};
